<template>
  <div class="StorageElements">
    <b-container fluid>
      <b-card-group deck>
      <b-card :title= "item.name" :border-variant="item.activeVariant" v-for="item in items" :id="item.name" :key="item.name"
      style="background-color: black; color: white">
      <b-progress height="3rem" :variant=item.variant class="mb-2">
        <b-progress-bar :value=item.used>
          <span style="color: black"><strong> Quota Used: {{ item.used.toFixed(0) }} %</strong></span>
        </b-progress-bar>
      </b-progress>
      <b-popover :variant="item.activeVariant" :target="item.name" triggers="hover" placement="top">
        <ul style="list-style-type:none;">
          <li>Active: {{item.active}}</li>
          <li>Storage Type: {{item.storage_type}}</li>
          <li>Available (GB): {{item.available_gb}}/{{item.total_gb}}</li>
          <li>Last Checked on: {{item.available_gb_last_checked.split('T')[0]}}</li>
          <li>Root Path: {{item.root}}</li>
          <li>Address: {{item.address}}</li>
        </ul>
      </b-popover>
      </b-card>
      </b-card-group>

    </b-container>
  </div>
</template>

<script>
// import { AuthVerificationMixin } from '../mixins/auth_mixin.js'
export default {
  // mixins: [AuthVerificationMixin],
  data () {
    return {
      eventNum: null,
      items: [],
      plots: {},
      smallTable: true,
      dark: false,
      fixed: true,
      currentPage: 1,
      perPage: 5,
      // totalRows: items.length,
      pageOptions: [ 5, 10, 15, 50, 100 ],
      sortBy: 'id',
      plot: null,
      sortDesc: true,
      sortDirection: 'asc',
      filter: null
    }
  },
  mounted () {
    // this.refreshToken()
    this.fetchStorageElements()
    // setInterval(this.fetchStorageElements, 5000)
  },
  computed: {
    totalRows () {
      return this.items.length
    }
  },
  methods: {
    fetchStorageElements () {
      var url = 'https://frb.chimenet.ca/maestro/datatrail/storage-elements'
      // this.refreshToken()
      var authHeaders = {'Authorization': localStorage.accessToken}
      this.$http.get(url, {headers: authHeaders}, {responseType: 'json', timeout: 10000})
        .then(response => {
          this.parseStorageElements(response.body)
        })
    },
    parseStorageElements (storageElements) {
      this.items = []
      for (let i = 0; i < storageElements.length; i++) {
        let item = storageElements[i]
        let maxAllowedLimit = item.total_gb - item.min_available_gb
        let usedGb = maxAllowedLimit - item.available_gb
        if (usedGb / maxAllowedLimit <= 0.75) {
          item.variant = 'success'
        } else if (usedGb / maxAllowedLimit < 0.90) {
          item.variant = 'warning'
        } else {
          item.variant = 'danger'
        }
        item.activeVariant = 'danger'
        if (item.active === true) {
          item.activeVariant = 'success'
        }
        item.used = 100 * usedGb / maxAllowedLimit
        this.items.push(item)
      }
    },
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Datatrail/storage_elements.vue